const config = {
    REWARD_REFERRED: 50,
    STORE_URL: 'https://store-spunfarmer.vercel.app',
  };
  
  export default config;